import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "concierge__emoji_3_full",
  "use": "concierge__emoji_3_full-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" stroke=\"var(--color-icons-alt, #fff)\" stroke-linecap=\"round\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"concierge__emoji_3_full\">\n  <circle cx=\"16\" cy=\"16\" fill=\"var(--color-icons-success, #2c9638)\" r=\"15.97\" stroke=\"none\" />\n  <path d=\"M9.01 13.08a1 1 0 0 1 3.72 0\" />\n  <path d=\"M19.17 13.08a1 1 0 0 1 3.72 0\" />\n  <path d=\"M8.85 19.4a8.2 8.2 0 0 0 14.85 0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol